export default class AccountBlockedByAdministratorException extends Error {

}
